<template>
  <div class="GlobalTable">
    <div v-if="seachDataList.length">
      <div
        v-for="(item, index) in seachDataList"
        style="margin-bottom: 20px"
        :key="item.customerOrderNo"
      >
        <div class="table_title">
          <div class="table_index">
            <div>{{ index + 1 }}</div>
          </div>
          <div
            :class="
              item.recycleType == '01' ? 'table_storeType' : 'table_storeType2'
            "
          >
            <div>{{ item.recycleType == "01" ? "上门回收" : "到店回收" }}</div>
          </div>
          <div class="table_orderNo">
            <div>订单编号：{{ item.customerOrderNo }}</div>
          </div>
          <div class="table_copy" @click="copyValue(item.customerOrderNo)">
            复制
          </div>
          <div class="table_orderNo">
            <div>下单时间：{{ item.orderTime || "--" }}</div>
          </div>
          <div class="table_orderNo">
            <div>关联回收订单：{{ item.recycleOrderNo || "--" }}</div>
          </div>
          <div class="table_orderNo">
            订单状态：
            <span v-if="item.state == '01'">已接单</span>
            <span v-else-if="item.state == '02'">待回收</span>
            <span v-else-if="item.state == '03'" class="green">已完成</span>
            <span v-else-if="item.state == '04'" class="ccc">已取消</span>
            <span v-else-if="item.state == '05'" class="red">已退回</span>
          </div>
          <div class="table_orderNo">
            <div>
              状态标记：{{
                item.stateStamp == "01"
                  ? "等待上门"
                  : item.stateStamp == "02"
                  ? "等待顾客到店"
                  : item.stateStamp == "03"
                  ? "未下回收单"
                  : item.stateStamp == "04"
                  ? "已下回收单"
                  : item.stateStamp == "05"
                  ? "已完成"
                  : item.stateStamp == "06"
                  ? "超时系统取消"
                  : item.stateStamp == "07"
                  ? "顾客取消"
                  : item.stateStamp == "08"
                  ? "员工操作取消"
                  : item.stateStamp == "09"
                  ? "回收单作废"
                  : item.stateStamp == "10"
                  ? "回收单退回"
                  : "--"
              }}
            </div>
          </div>
        </div>
        <div class="table_list">
          <el-table
            ref="tableGroup"
            :highlight-current-row="true"
            stripe
            :data="[item]"
            size="small"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="customerOrderNo"
              label="订单编号"
              align="center"
            >
              <template slot-scope="{ row }">
                <div style="text-align: center">{{ row.customerOrderNo }}</div>
                <div
                  style="text-align: center"
                  @click="handleClick(row.recycleOrderNo)"
                  v-if="row.recycleOrderNo"
                >
                  <div style="color: #0981ff; cursor: pointer">
                    关联回收单：
                  </div>
                  <div class="textdown" style="color: #0981ff; cursor: pointer">
                    {{ row.recycleOrderNo }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="goodsName" label="旧机名称" align="center">
            </el-table-column>
            <el-table-column label="用户信息" align="center">
              <template slot-scope="{ row }">
                <div style="text-align: center">{{ row.createNickName }}</div>
                <div style="text-align: center">{{ row.createUserPhone }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="receiveStaffName"
              label="接单人"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="receiveStoreName"
              label="接单门店"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="serveStaffName"
              label="实际处理人"
              align="center"
            >
              <template slot-scope="{ row }">
                <div style="text-align: center">
                  {{ row.serveStaffName ? row.serveStaffName : "--" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="serveStoreName"
              label="受理门店"
              align="center"
            >
              <template slot-scope="{ row }">
                <div style="text-align: center">
                  {{ row.serveStoreName ? row.serveStoreName : "--" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="arriveTimeRegion"
              label="预约时间"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="userSubmitPrice"
              label="线上预估价"
              align="center"
            >
            <template slot-scope="{ row }">
                <div style="text-align: center" >
                  ￥{{ row.userSubmitPrice }}
                </div>
                <div style="text-align: center" v-if="row.userSubmitPriceType!=='01'&&row.leftSideUserSubmitPrice">
                  ({{ row.leftSideUserSubmitPrice }}~{{ row.rightSideUserSubmitPrice }})
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="staffSubmitPrice"
              label="门店确认估价"
              align="center"
            >
              <template slot-scope="{ row }">
                <div style="text-align: center" v-if="row.staffSubmitPrice">
                  <span>￥{{ row.staffSubmitPrice }}</span>
                  <div v-if="row.userSubmitPriceType !=='01'&&row.leftSideStaffSubmitPrice">({{ row.leftSideStaffSubmitPrice }}~{{ row.rightSideStaffSubmitPrice }})</div>
                </div>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="recycleFinalPrice"
              label="顾客成交价"
              align="center"
            >
              <template slot-scope="{ row }">
                <div style="text-align: center">
                  {{ row.recycleFinalPrice ? row.recycleFinalPrice : "--" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="usePoints" label="使用积分" align="center">
              <template slot-scope="{ row }">
                <div style="text-align: center">
                  {{ row.usePoints ? row.usePoints : "--" }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="isGrant" label="赠送礼包" align="center">
              <template slot-scope="{ row }">
                <div style="text-align: center">
                  {{ row.isGrant==null?'--':row.isGrant?'已发放':'未发放' }}
                </div>
                <div
                  v-if="row.isGrant != null"
                  class="textdown"
                  style="cursor: pointer"
                  @click="seeGift(row)"
                >
                  查看
                </div>
              </template>
            </el-table-column>
            <!-- 时间 -->

            <el-table-column
              v-if="item.state == '04'"
              prop="cancelTime"
              label="取消时间"
              align="center"
            >
              <template slot-scope="{ row }">
                <div style="text-align: center">
                  {{ row.cancelTime ? row.cancelTime : "--" }}
                </div>
                <div
                  v-if="row.cancelCause"
                  class="textdown"
                  style="cursor: pointer"
                  @click="cancelCause(row.cancelCause)"
                >
                  取消原因
                </div>
              </template>
            </el-table-column>

            <el-table-column
              v-else-if="item.state == '05' || item.stateStamp == '10'"
              prop="refundTime"
              label="退回时间"
              align="center"
            >
              <template slot-scope="{ row }">
                <div style="text-align: center">
                  {{ row.refundTime ? row.refundTime : "--" }}
                </div>
                <div
                  v-if="row.refundCause"
                  class="textdown"
                  style="cursor: pointer"
                  @click="refundTime(row.refundCause)"
                >
                  退回原因
                </div>
              </template>
            </el-table-column>

            <el-table-column
              v-else
              prop="finishTime"
              label="完成交易时间"
              align="center"
            >
              <template slot-scope="{ row }">
                <div style="text-align: center">
                  {{ row.finishTime ? row.finishTime : "--" }}
                </div>
              </template>
            </el-table-column>
            <!-- 时间 -->

            <el-table-column label="操作" align="center">
              <template slot-scope="{ row }">
                <el-button
                  size="small"
                  type="text"
                  @click="noticeLink(row.customerOrderNo)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <div
      v-else
      style="
        width: 100%;
        text-align: center;
        padding: 80px 0;
        font-size: 24px;
        color: #666666;
        background: white;
        font-weight: bold;
      "
    >
      暂无订单~
    </div>
    <div class="orderPagina">
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-size="page.pageSize"
        layout="total, prev, pager, next,jumper"
        :total="page.total"
        class="el-pagination-c"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 取消原因 -->
    <el-dialog
      title="取消原因"
      :visible.sync="delDialogVisible"
      :close-on-click-modal="false"
      width="400px"
      @closed="delDialogVisible = false"
    >
      <div class="mb-20">{{ CancelCauseText }}</div>
      <!-- <el-input
        v-model="formData.remark"
        placeholder="请输入谷歌动态验证码"
      ></el-input> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="delDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="退回原因"
      :visible.sync="refundTimeDialog"
      :close-on-click-modal="false"
      width="400px"
      @closed="refundTimeDialog = false"
    >
      <div class="mb-20">{{ refundTimeText }}</div>
      <!-- <el-input
        v-model="formData.remark"
        placeholder="请输入谷歌动态验证码"
      ></el-input> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="refundTimeDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="bagListShow"
      title="礼包内容"
      :close-on-click-modal="false"
      width="750px"
      @closed="bagListClose"
    >
      <div class="flex flex-jb mb-20">
        <div class="flex">
          <span>线上订单号：</span>
          <span class="textdown" style="cursor: pointer">{{giftOrder.customerOrderNo}}</span>
        </div>
        <div class="flex">
          <span>{{giftOrder.recycleFinalPrice?'顾客成交价':giftOrder.staffSubmitPrice?'门店确认估价':'线上预估价'}}：</span>
          <span style="color:#0981ff;">{{giftOrder.recycleFinalPrice || giftOrder.staffSubmitPrice || giftOrder.userSubmitPrice}}元</span>
        </div>
        <div class="flex">
          <span>礼包状态：</span>
          <span :style="giftOrder.isGrant?'color:#0981ff':'color:red;'">{{giftOrder.isGrant?'已发放':'未发放'}}</span>
        </div>
      </div>
      <GlobalTable
        ref="GlobalTable"
        v-loading="bagListloading"
        :columns="bagListColumns"
        :data="bagList"
        :maxHeight="500"
        :isPagination="false"
      >
        <el-table-column label="赠品类型" slot="giftType" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.giftType == "01" ? "换新补贴" : "回收赠礼" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="赠品价值/最高补贴"
          slot="giftPrice"
          align="center"
        >
          <template slot-scope="{ row }"> {{ row.giftPrice || 0 }}元 </template>
        </el-table-column>
        <el-table-column label="发放门槛" slot="giveType" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.giveType == '02'">无门槛(可叠加)</span>
            <span v-if="row.giveType == '01'"
              >订单金额满{{ row.threshold }}元</span
            >
          </template>
        </el-table-column>
      </GlobalTable>
      <div class="mt-20" v-if="giftOrder.renewNewImei">
        <span>参与换新活动串号：</span>
        <span>{{giftOrder.renewNewImei}}</span>
      </div>
      <div class="mt-20 flex flex-as" v-if="giftOrder.renewBuyProof">
        <span>参与换新活动购买凭证：</span>
        <el-image
          :preview-src-list="[giftOrder.renewBuyProof]"
          style="width: 120px; height: 120px;border-radius: 10px;"
          :src="giftOrder.renewBuyProof"
          fit="cover"
        ></el-image>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="bagListShow = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
export default {
  name: "Table",
  data() {
    return {
      seachDataList: [],
      dialogVisible: false,
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      delDialogVisible: false,
      commentId: "",
      CancelCauseText: "",
      refundTimeDialog: false,
      refundTimeText: "",
      bagListShow: false,
      bagListloading: false,
      bagListColumns: [
        { label: "赠品名称", prop: "giftName" },
        { slotName: "giftType" },
        { slotName: "giftPrice" },
        { slotName: "giveType" },
      ],
      bagList: [],
      giftOrder: {}
    };
  },
  created() {
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newVal) {
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
  },
  methods: {
    // 表格切换页面
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      }
      const baseRequest = {
        recycleType: this.SeachParams.recycleType,
        states: this.SeachParams.states,
        stateStamps: this.SeachParams.stateStamps,
        storeName: this.SeachParams.storeName,
        orderStartTime: this.SeachParams.orderStartTime, //下单开始时间
        orderEndTime: this.SeachParams.orderEndTime, //下单结束时间
        userName: this.SeachParams.userName,
        userPhone: this.SeachParams.userPhone,
        arriveStartTime: this.SeachParams.arriveStartTime, //预约开始时间
        arriveEndTime: this.SeachParams.arriveEndTime, //预约结束时间
        finishStartTime: this.SeachParams.finishStartTime, //完成开始时间
        finishEndTime: this.SeachParams.finishEndTime, //完成结束时间
        customerOrderNo: this.SeachParams.customerOrderNo, //完成结束时间
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };

      _api.assessOrderList(baseRequest).then((res) => {
        if (res.code === 1) {
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    // 复制
    copyValue(context) {
      // 创建输入框元素
      let oInput = document.createElement("input");
      // 将想要复制的值
      oInput.value = context;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      // 弹出复制成功信息
      this.$message.success("复制成功");
      // 复制后移除输入框
      oInput.remove();
    },
    //uyu
    cancelCause(text) {
      this.delDialogVisible = true;
      this.CancelCauseText = text;
    },
    handleClick(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row },
      });
      window.open(routeData.href, "_blank");
    },
    // 退回
    refundTime(text) {
      this.refundTimeDialog = true;
      this.refundTimeText = text;
    },
    // 详情
    noticeLink(orderNo) {
      let routeData = this.$router.resolve({
        path: "/OnlinreyService/OrderDetails",
        query: {
          orderNo,
        },
      });
      window.open(routeData.href, "_blank");
      // this.$router.push("/OnlinreyService/OrderDetails?orderNo=" + orderNo);
    },
    // 查看礼包
    seeGift(row) {
      this.bagListShow = true
      this.bagListloading = true
      this.giftOrder = {
        customerOrderNo: row.customerOrderNo,
        recycleFinalPrice: row.recycleFinalPrice,
        staffSubmitPrice: row.staffSubmitPrice,
        userSubmitPrice: row.userSubmitPrice,
        isGrant: row.isGrant,
      }
      _api.orderGiftInfo({customerOrderNo:row.customerOrderNo}).then(res => {
        if(res.code == 1){
          console.log(res);
          this.bagList = res.data.giftInfoViews
          this.giftOrder.renewBuyProof = res.data.renewBuyProof
          this.giftOrder.renewNewImei = res.data.renewNewImei
        }
        this.bagListloading = false
      })
    },
    bagListClose() {
      this.giftOrder = {}
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  .table_title {
    display: flex;
    height: 40px;
    padding: 10px 0;
    align-items: center;
    background: #e4ecfd;
    border-radius: 6px 6px 0px 0px;
  }
  .table_index {
    background: #fcba05;
    height: 20px;
    padding: 0 10px;
    color: #fff;
    text-align: center;
    line-height: 20px;
    border-radius: 3px 10px 10px 3px;
    margin-left: -5px;
  }
  .table_storeType {
    background: #52a7ff;
    height: 25px;
    padding: 0 10px;
    color: #fff;
    text-align: center;
    line-height: 25px;
    margin-left: 20px;
    border-radius: 20px;
    font-size: 14px;
  }
  .table_storeType2 {
    background: #fcba05;
    height: 25px;
    padding: 0 10px;
    color: #fff;
    text-align: center;
    line-height: 25px;
    margin-left: 20px;
    border-radius: 20px;
    font-size: 14px;
  }
  .table_orderNo {
    color: #0981ff;
    font-size: 14px;
    margin-left: 20px;
    padding: 0 5px;
  }
  .table_copy {
    cursor: pointer;
    color: #fff;
    text-align: center;
    line-height: 20px;
    margin-left: 10px;
    border-radius: 5px;
    font-size: 14px;
    padding: 0 5px;
    background: #0981ff;
  }
  .red {
    color: red;
  }
  .green {
    color: #00b305;
  }
  .ccc {
    color: #707070;
  }
  .mt-20{
    margin-top: 20px;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mr-50 {
    margin-right: 50px;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .mr-10 {
    margin-right: 10px;
  }
  .font-w {
    font-weight: bold;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex-jb {
    display: flex;
    justify-content: space-between;
  }
  .flex-as {
    display: flex;
    align-items: flex-start;
  }
  .flex-ja{
    display: flex;
    justify-content: space-around;
  }
  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }
  .images-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .images-box > img {
    width: 70px;
    height: 70px;
    margin-bottom: 10px;
  }
  .images-box > span {
    color: #0981ff;
    cursor: pointer;
  }
  .textdown {
    color: #0981ff;
    text-decoration: underline;
  }
  .orderPagina {
    float: right;
    margin: 50px;
  }
}
</style>
